/**
 * @module events/types/dragLeave
 */

/**
 * @type {string}
 */
export default 'dragleave'
